module.exports = __webpack_public_path__ + "static/media/showPreviousLicences.78f44034.svg";